// Modelo Tipos para administrador.
export default class Type {
    id=""
    name=""
    description=""
    elements=[]
}



// WEBPACK FOOTER //
// ./src/model/Type.js